import { Outlet } from 'react-router'
import { DefaultTheme, ThemeProvider } from 'styled-components'
import GlobalStyles from 'src/styles/globalStyles'
import Modal from 'src/components/Modal'
import { useSyncSentryUser } from 'src/service/utils/sentry/syncUser'

interface LayoutProps {
  theme: DefaultTheme
}

const Layout = ({ theme }: LayoutProps) => {
  useSyncSentryUser()

  return (
    <ThemeProvider theme={theme}>
      <Outlet />
      <Modal />
      <GlobalStyles />
    </ThemeProvider>
  )
}

export default Layout
